/* eslint-disable */
// import '@babel/polyfill';

import 'jquery-toast-plugin';

// /**
//  * rem 相关的工具
//  * @param {*}
//  */
// export const remUtil = {
// 	// 调整窗口或者翻转屏幕事件
// 	resizeEvent: 'orientationchange' in window ? 'orientationchange' : 'resize',
// 	// 事件句柄
// 	handlers: [],
// 	// 添加设置rem的事件
// 	addRemHandler: function(designWith) {
// 		function recalc() {
// 			const docEl = document.documentElement;
// 			const clientWidth = docEl.clientWidth;
// 			if (!clientWidth) return;
// 			docEl.style.fontSize = 100 * (clientWidth / Number(designWith)) + 'px';
// 		}

// 		if (!document.addEventListener) return;
// 		const handler = throttle(recalc, 500);
// 		remUtil.handlers.push(handler);
// 		window.addEventListener(remUtil.resizeEvent, handler, false);
// 		document.addEventListener('DOMContentLoaded', recalc, false);
// 	},
// 	// 移除设置rem的事件
// 	removeRemHandler: function() {
// 		remUtil.handlers.forEach((handler) => {
// 			window.removeEventListener(remUtil.resizeEvent, handler);
// 		});
// 	}
// };

// /**
//  * 删除html上的行内style
//  */
// export function removeAttributeOfHtml() {
// 	const docEl = document.documentElement;
// 	if (!docEl) return;
// 	docEl.removeAttribute('style');
// }

// /**
//  * viewport的宽度是否比某个值大
//  * @param {*} width
//  */
// export function isWider(width) {
// 	const viewPortSize = getViewportSize();
// 	if (viewPortSize.width > width) {
// 		return true;
// 	}
// 	return false;
// }

// /**
//  * 获取viewport的宽高
//  */
// export function getViewportSize() {
// 	return {
// 		width: window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth,
// 		height: window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight
// 	};
// }

// /**
//  * 设置样式
//  * @param {*} href
//  */
// export function setLink(className) {
// 	let heads = document.getElementsByTagName('head');
// 	let htmlTags = document.getElementsByTagName('html');
// 	let htmlTag = htmlTags ? htmlTags[0] : null;
// 	htmlTag.setAttribute('class', className);
// }

// /**
//  * 节流函数，你懂的。
//  */
// export function throttle(action, delay) {
// 	let timeout = null;
// 	let lastRun = 0;
// 	return function() {
// 		if (timeout) return;
// 		let elapsed = Date.now() - lastRun;
// 		let context = this;
// 		let args = arguments;
// 		let runCallback = function() {
// 			lastRun = Date.now();
// 			timeout = false;
// 			action.apply(context, args);
// 		};
// 		if (elapsed >= delay) {
// 			runCallback();
// 		} else {
// 			timeout = setTimeout(runCallback, delay);
// 		}
// 	};
// }

const script = `<script type="text/javascript">var Tawk_API=Tawk_API||{}, Tawk_LoadStart=new Date();
(function(){
var s1=document.createElement("script"),s0=document.getElementsByTagName("script")[0];
s1.async=true;
s1.src='https://embed.tawk.to/5fea8a57df060f156a916343/1eqm2oq78';
s1.charset='UTF-8';
s1.setAttribute('crossorigin','*');
s0.parentNode.insertBefore(s1,s0);
})()</script>`;

const scriptDom = $(script);

$('body').append(scriptDom);

import homeImgUrl from '../images/Home/partner Brand@2x.png';
import featureImgUrl from '../images/Feature/illustration.svg';
import aboutImgUrl from '../images/About/illustration.svg';
import aboutMapImgUrl from '../images/About/map.svg';
import contactMapImgUrl from '../images/Contact/illustration.svg';

$('.h-partner-img').attr('src', homeImgUrl);
$('.h-feature-banner-img').attr('src', featureImgUrl);
$('.h-about-banner-img').attr('src', aboutImgUrl);
$('.h-about-map-img').attr('src', aboutMapImgUrl);
$('.h-contact-banner-img').attr('src', contactMapImgUrl);

const TOAST_MAP = {
	success: '#0ac50a',
	error: '#ea4949',
	warning: 'orange'
};

const toastCommon = (test, status) => {
	$.toast({
		text: test,
		showHideTransition: 'fade', // It can be plain, fade or slide
		bgColor: TOAST_MAP[status], // Background color for toast
    textColor: '#fff', // text color
    allowToastClose : false, 
		hideAfter: 5000, // `false` to make it sticky or time in miliseconds to hide after
		stack: 1, // `fakse` to show one stack at a time count showing the number of toasts that can be shown at once
		textAlign: 'center', // Alignment of text i.e. left, right, center
		position: 'top-center' // bottom-left or bottom-right or bottom-center or top-left or top-right or top-center or mid-center or an object representing the left, right, top, bottom values to position the toast on page
	});
};

const sendApi = () => {
	var response = $.ajax({
		url: `/api/v1/accounts/profile`,
		type: 'get',
		dataType: 'json'
	});
	return response;
};

const logoutApi = () => {
	var response = $.ajax({
		url: `/api/v1/accounts/sign-out`,
		type: 'patch',
		dataType: 'json'
	});
	return response;
};

const getProfile = () => {
	var query = sendApi();
	query
		.done((data) => {
			if (data.code == 0) {
				// 已登陆
				localStorage.setItem('freesslorg-login', true);
				btnStatus();
			}
		})
		.fail((response) => {
			if (response.status === 401) {
				// 未登陆
				localStorage.setItem('freesslorg-login', false);
				btnStatus();
			}
		});
};

getProfile();

const btnStatus = () => {
	if (localStorage.getItem('freesslorg-login') === 'true') {
		// console.log('----', localStorage.getItem('freesslorg-login') === 'true');
		// 登陆
		$('#h-signin-btn,#h-signup-btn,#h-signin-mobile-btn,#h-signup-mobile-btn').addClass('hide');
		$('#h-signout-btn,#h-signout-mobile-btn, #h-account-btn, #h-account-mobile-btn').removeClass('hide');
	} else {
		// console.log('----', '未登陆');
		// 未登陆
		$('#h-signin-btn,#h-signup-btn, #h-signin-mobile-btn,#h-signup-mobile-btn').removeClass('hide');
		$('#h-signout-btn, #h-signout-mobile-btn, #h-account-btn, #h-account-mobile-btn').addClass('hide');
	}
};

window.addEventListener('resize', btnStatus());

$('#h-signout-btn, #h-signout-mobile-btn').click((e) => {
	e.preventDefault();
	var query = logoutApi();
	query
		.done((data) => {
			if (data.code == 10 || data.code == 0) {
				// 退出成功
				toastCommon(data.msg, 'success');
				localStorage.setItem('freesslorg-login', false);
				btnStatus();
			}
		})
		.fail((response) => {});
});

$('#h-create-cert').click((e) => {
	e.preventDefault();

	const domain = $('#domain').val();
	toastCommon('Please enter the domain name in the correct format', 'warning');
	if (domain && domain.indexOf('.') >= 0) {
		if (/\d+$/.test(domain)) {
			toastCommon('All brands do not support IP. Drop it', 'warning');
			return;
		}
		let domainVal = domain
			.toLowerCase()
			.replace('http://', '')
			.replace('https://', '')
			.split('?')[0]
			.split('#')[0]
			.split('/')[0]
			.replace(/\s+/g, ' ')
			.trim();

		window.location.href = `${window.location.origin}/create-certificate?domains=${domainVal}`;
	} else {
		toastCommon('Please enter the domain name in the correct format', 'warning');
	}
});
